import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import {AuthenticationService} from '../../_services/authentication.service';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})

export class AlertsComponent implements OnInit {
  @ViewChild('snav', {static: true}) snav: MatSidenav;
  @Input() currentCompany: any;
  @Input() mode: any;
  alertsColOptions: any;
  alertsQuery: any = {};
  eventsQuery: any = {};
  currentAlert: any = {};
  dynamicColumns: any = [];
  dynamicEventsColumns: any = [];
  eventsColOptions: any = {};
  eventColumns: any = [];

  constructor(public aS: AuthenticationService) {
  }

  totalCallbackCheck($event: any): void { // @ts-ignore
    if (this[$event.id]) { // @ts-ignore
      this[$event.id].hideTable = ($event.value === 0);
    } else {
      console.log($event.id + ' not available');
    }
  }

  viewEvents(idata: any): void {
    this.currentAlert = idata.row;
    this.snav.open();
    this.getEventsData();
  }

  close(status?: any): void {
    if (status) {
      return;
    }
    this.snav.close();
  }

  ngOnInit(): void {
    this.dynamicColumns = [
      {
        col: 'u', header: 'Last updated', colFilters: {type: 'text', hKey: false}, hyperLinkCall: {
          filter: 'utcToLocale'
        }
      },
      {
        col: 'status', header: 'Status', isKeyword: true,
        htmlCols: {
          Open: `<span class=" fw4 ml-3 px-1 badge badge-danger">Open</span>`,
          Closed: `<span class=" fw4 ml-3 px-1 badge badge-success">Closed</span>`
        },
        colFilters: {
          type: 'select', hKey: false,
          options: [{value: 'Open', name: 'Open'}, {value: 'Closed', name: 'Closed'}]
        },
      },
      {col: 'name', header: 'Name', colFilters: {type: 'text', hKey: true}, isKeyword: true, noFilter: true},
      {col: 'description', header: 'Description', colFilters: {type: 'text', hKey: true}, isKeyword: true, noFilter: true},
      {col: 'assetRef.name', header: 'Asset Name', colFilters: {type: 'text', hKey: true}, isKeyword: true, noFilter: true},
    ];

    this.eventColumns = [
      {col: 'u', header: 'Last updated', colFilters: {type: 'text', hKey: false}, filter: 'utcToLocale'},
      {
        col: 'status', header: 'Status',
        htmlCols: {
          Open: `<span class=" fw4 ml-3 px-1 badge badge-danger">Open</span>`,
          Closed: `<span class=" fw4 ml-3 px-1 badge badge-success">Closed</span>`
        },
        colFilters: {
          type: 'select', hKey: false,
          options: [{value: 'Open', name: 'Open'}, {value: 'Closed', name: 'Closed'}]
        }, isKeyword: true,
      },
      {col: 'name', header: 'Name', colFilters: {type: 'text', hKey: true}, isKeyword: true, noFilter: true},
      {col: 'description', header: 'Description', colFilters: {type: 'text', isKeyword: true, hKey: true}, noFilter: true},
      {
        col: 'integrationMap.integrationName',
        header: 'Integration Name',
        colFilters: {type: 'text', hKey: true}, isKeyword: true,
        noFilter: true
      },
      {col: 'integrationMap.ticketId', header: 'Ticket No', colFilters: {type: 'text', hKey: true}, isKeyword: true, noFilter: true},
      {
        col: 'integrationMap.ticketStatus',
        header: 'Ticket Status',
        colFilters: {type: 'text', hKey: true}, isKeyword: true,
        noFilter: true
      },
    ];
    this.getAlertsData();
  }

  getAlertsData(): void {
    if (this.mode === 'company' && this.currentCompany && this.currentCompany._id) {
      this.alertsQuery = {
        query: {
          bool: {
            must: [{match: {'companyRef.id.keyword': this.currentCompany._id}},
              {exists: {field: 'description'}}, {exists: {field: 'name'}}, {exists: {field: 'status'}}],
            should: [
              {match: {'status.keyword': 'Open'}}, {match: {'status.keyword': 'Closed'}}],
            must_not: [{exists: {field: 'alertsRef'}}]
          }
        }
      };
    } else {
      this.dynamicColumns.push(
        {col: 'companyRef.name', header: 'Company Name', colFilters: {type: 'text', hKey: true},  isKeyword: true, noFilter: true},
      );
      this.alertsQuery = {
        query: {
          bool: {
            must: [{exists: {field: 'description'}}, {exists: {field: 'name'}}, {exists: {field: 'status'}}],
            should: [{match: {'status.keyword': 'Open'}}, {match: {'status.keyword': 'Closed'}}],
            must_not: [{exists: {field: 'alertsRef'}}]
          }
        }
      };
    }
    this.alertsColOptions = {};
    setTimeout(() => {
      this.alertsColOptions = {
        id: 'alertsColOptions',
        title: 'Alerts',
        refresh: true,
        cFilter: true,
        pSize: 200,
        pList: [1, 5, 10, 25, 50, 100, 200],
        pagination: true,
        loading: true,
        customCols: true,
        faClass: 'Alerts',
        serverSide: {
          service: 'alertsService', fn: 'getAllApiAlertsGet', q: this.alertsQuery, sort: [{u: {order: 'desc'}}]
        },
        lMsg: 'Getting alerts...',
        local: false,
        dataList: [],
        columns: this.dynamicColumns
      };
    });
  }

  getEventsData(): void {
    this.eventsQuery = {
      query: {
        bool: {
          must: [
            {match: {'alertsRef.id.keyword': this.currentAlert._id + ''}},
            {exists: {field: 'description'}}, {exists: {field: 'name'}}, {exists: {field: 'status'}},
            {exists: {field: 'alertsRef'}}], should: [{match: {'status.keyword': 'Open'}},
            {match: {'status.keyword': 'Closed'}}]
        }
      }
    };
    this.eventsColOptions = {};
    setTimeout(() => {
      this.eventsColOptions = {
        id: 'eventsColOptions',
        title: 'Events',
        refresh: true,
        cFilter: true,
        pSize: 5,
        pList: [1, 5, 10, 25, 50, 100, 200],
        pagination: true,
        loading: true,
        customCols: true,
        faClass: 'Alerts',
        serverSide: {
          service: 'eventsService', fn: 'getAllApiEventsGet', q: this.eventsQuery, sort: [{u: {order: 'desc'}}]
        },
        lMsg: 'Getting alerts...',
        local: false,
        dataList: [],
        columns: this.eventColumns
      };
    });
  }
}
